import { useState } from "react"
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"

import { useAppSelector } from "../../../app/hooks"
import { selectUserId } from "../../../app/data/appTokensStore"
import { useGetUserQuery } from "../../../app/data/tribeSwaggerApi"
import { securitySettings } from "../../../consts"

import {
  securityList,
  securityListItem,
  securityListButton,
  securityListIcon,
  securityListText,
} from "./securitySettingsStyle"
import s from "./styles.module.scss"

const SecuritySettings = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(
    undefined,
  )

  const userId = useAppSelector(selectUserId)!.toString()
  const { data: { email, phone_number } = { email: "", phone_number: "" } } =
    useGetUserQuery({ userId })
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement>,
    index: number,
  ) => {
    setSelectedIndex(index)
    handleClickOpen()
  }

  const userAuthMethods: { [key: string]: string } = {
    phone:
      phone_number && phone_number.length >= 4
        ? maskPhone(phone_number)
        : "не указан",
    email: email ? maskEmail(email) : "не указана",
    password: maskPassword("password"), //я не получаю пароля, но его тут и не нужно
  }

  function maskPhone(phone: string) {
    if (phone.length < 8)
      return phone.slice(0, 1) + "*".repeat(phone.length - 2) + phone.slice(-1)
    else
      return phone.slice(0, 8) + "*".repeat(phone.length - 7) + phone.slice(-2)
    //TODO: проверить в каком формате приходит номер телефона -> в зависимости от этого оставить кол-во знаков в начале
  }

  function maskEmail(email: string) {
    const atIndex = email.indexOf("@")
    const maskedPart = email.slice(1, atIndex)
    return email.replace(maskedPart, "*".repeat(maskedPart.length))
  }

  function maskPassword(password: string) {
    return password.replace(/./g, "*")
  }

  const combinedSettings = securitySettings.map((setting) => ({
    ...setting,
    authValue: userAuthMethods[setting.alt],
  }))

  return (
    <div className={s.security_container}>
      <List sx={securityList}>
        {combinedSettings.map((item, index) => (
          <ListItem key={item.text} sx={securityListItem} disablePadding>
            <ListItemButton
              sx={securityListButton}
              role={undefined}
              selected={selectedIndex === index}
              onClick={(event) => handleListItemClick(event, index)}
              dense
              disableGutters
            >
              <ListItemIcon sx={securityListIcon}>
                <item.icon />
              </ListItemIcon>

              <ListItemText
                id={item.text}
                primary={item.text}
                secondary={item.authValue}
                sx={securityListText}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault()
              const formData = new FormData(event.currentTarget)
              const formJson = Object.fromEntries((formData as any).entries())
              const inputEmail = formJson.email
              if (inputEmail === email) {
                console.log(
                  "Все ОК. Скоро тут будет функция по смене емейла/пароля",
                )
              } else {
                console.log("не совпадает")
              }

              handleClose()
            },
          }}
        >
          <DialogTitle>Смена почты/пароля</DialogTitle>
          <DialogContent>
            <DialogContentText>Введите почту</DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              name="email"
              label="email"
              type="email"
              fullWidth
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Отмена</Button>
            <Button type="submit">Сменить</Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  )
}
export default SecuritySettings
